import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useEffect, useState } from 'react';
import { api } from '../../api';
import { AreaZone } from '../../schema/area';

interface AreaZoneFromInputProps {
  required?: boolean;
  value?: number | null;
  onChange?: (value: number | null) => void;
  canSelectAll?: boolean;
}

const AreaZoneFromInput: React.FC<AreaZoneFromInputProps> = ({
  required,
  value,
  onChange,
  canSelectAll
}: AreaZoneFromInputProps) => {
  const [areaZoneList, setAreaZoneList] = useState<AreaZone[]>([]);
  useEffect(() => {
    api.get<AreaZone[]>(`/area_zone`).then((res) => {
      const { data } = res;
      setAreaZoneList(data);
    });
  }, []);

  return (
    <FormControl fullWidth>
      <InputLabel>{`โชน${required ? ' *' : ''}`}</InputLabel>
      <Select
        label={`โชน${required ? ' *' : ''}`}
        variant="outlined"
        onChange={(e) => {
          if (onChange) {
            const parsed = parseInt(e.target.value);
            if (isNaN(parsed)) {
              onChange(null);
              return;
            }
            onChange(parsed);
          }
        }}
        value={value != null ? `${value}` : ''}
        autoComplete="off"
        required={required}
      >
        {canSelectAll ? <MenuItem value="">ทั้งหมด</MenuItem> : null}
        {areaZoneList.map((data, index) => (
          <MenuItem key={index} value={`${data.id}`}>
            {data.zone_name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default AreaZoneFromInput;
